import type { FiltersState } from '../../hooks/useFilters';
import type { SourceModule, SourceVacancyParams } from '../sourceModules/types';
import { avitoConfig } from './config';
import { avitoFilterAdapter } from './filterAdapter';
import {
  AVITO_FILTER_BUCKET_ID,
  buildAvitoFiltersForSourceSwitch,
  clearAvitoOwnedFields,
  getActiveAvitoFiltersCount,
  getDefaultAvitoFilters,
  getAvitoTransferableFilters,
  getSerializableAvitoFilters,
  sanitizeAvitoFilters,
} from './filterPolicy';
import { mapAvitoVacancyToFilters } from './vacancyMapper';

const mapVacancy = ({ vacancy, filters, sourceFilters }: SourceVacancyParams): Partial<FiltersState> => (
  mapAvitoVacancyToFilters(vacancy, filters, sourceFilters)
);

export const avitoSourceModule: SourceModule = {
  id: 'avito',
  config: avitoConfig,
  filters: {
    bucketId: AVITO_FILTER_BUCKET_ID,
    adapter: avitoFilterAdapter,
    sanitize: sanitizeAvitoFilters,
    getDefaultFilters: getDefaultAvitoFilters,
    getSerializableFilters: getSerializableAvitoFilters,
    getTransferableFilters: getAvitoTransferableFilters,
    buildForSourceSwitch: buildAvitoFiltersForSourceSwitch,
    clearOwnedFields: clearAvitoOwnedFields,
    fromVacancy: mapVacancy,
    getActiveFiltersCount: getActiveAvitoFiltersCount,
  },
};

export { avitoConfig } from './config';
export { avitoFilterAdapter } from './filterAdapter';
export {
  buildAvitoFiltersForSourceSwitch,
  clearAvitoOwnedFields,
  getActiveAvitoFiltersCount,
  getDefaultAvitoFilters,
  getAvitoTransferableFilters,
  getSerializableAvitoFilters,
  sanitizeAvitoFilters,
} from './filterPolicy';
export {
  mapHhEducationToAvitoEducation,
  mapHhTotalExperienceToAvitoExperience,
  mapHhWorkFormatToAvitoSchedule,
  mapHhWorkScheduleToAvitoSchedule,
  mapHhWorkingHoursToAvitoSchedule,
  mergeAvitoScheduleMappings,
} from './filterMappings';
export { mapAvitoVacancyToFilters, normalizeAvitoVacancyList } from './vacancyMapper';
